import React from 'react';
import Select from 'react-select';

/**
 * Breed Select Switcher component
 */
const BreedSwitcher = (props) => {
  let options = [];
  props.data.map((value, index) => {
    options.push({
      value: index,
      label: value.label,
      listOrder: value.listOrder,
    });
  });

  // #ea6b6a
  const customStyles = {
    option: (provided, state) => ( () => {
      return {
        ...provided,
        color: state.isSelected ? '#ea6b6a' : '#333',
        background: state.isSelected ? '#ea6b6a' : 'white',
      }
    }),
  }

  return (
    <div className="nppe2-fc-breed-switcher">
      <div className="nppe2-fc-sub-title">{props.label}</div>
      <Select
        options={options}
        className="nppe2-fc-react-select"
        name="nppe2-fc-breed-switcher-select"
        onChange={(selectedOption) => {
          props.onResetSelectedProducts()
          props.onSelect(selectedOption.value)
        }}
        value={options[props.selected]}
        styles={customStyles}
        aria-label={props.label}
        noOptionsMessage={() => props.noOptionsMsg}
      />
    </div>
  )
};

export default BreedSwitcher;
